/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (window.boostSDAppConfig) {
    window.boostSDAppConfig.integration = Object.assign({
        labels: 'flair'
    }, window.boostSDAppConfig.integration || {});
}
const customize = {
    updateProductItem: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'Add Flair under the title',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    let productData = element.getParams().props.product;
                    let productItem = document.querySelector('.boost-sd__product-item[data-product-id="' + productData.id + '"]');
                    let flairEl = productItem.querySelector('[data-flair-product-badge]');
                    if (flairEl) {
                        productItem.querySelector('.boost-sd__product-title').after(flairEl);
                    }
                }
            }),
        });
    }
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItem]);

const updateProductItem = (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
        name: 'Add logo to product img',
        enabled: true,
        apply: () => ({
            afterRender(element) {
                let productData = element.getParams().props.product;
                let productItem = document.querySelector('[data-product-id="' + productData.id + '"]');
                // Start Boost #214786 - Hide price for produts with specific template
                if (productData.template_suffix == "call-for-price" || productData.template_suffix == "router-service-visit" || productData.price_min == 0) {
                    // let callHTML = '<span class="bc-sf-filter-product-item-regular-price "><a href="/products/' + productData.handle + '">Call For Price</a></span>';
                    let callHTML = '<span class="bc-sf-filter-product-item-regular-price "><a href="/products/' + productData.handle + '" style="color: #00b2e2; font-weight: 600;">Please call for price and availability</a></span>';
                    productItem.querySelector('.boost-sd__product-price').innerHTML = callHTML;
                    // Hide ATC
                    productItem.querySelector('button.boost-sd__btn-add-to-cart').style.display = 'none';
                }
                // End Boost #214786 - Hide price for products with specific template
            }
        }),
    });
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([updateProductItem]);